/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftDatePicker from "components/SoftDatePicker";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable4({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      value29: "",
      value30: "",
      value31: "",
      value32: "",
      value33: "",
      value34: "",
      value35: "",
      value36: "",
      value37: 0,
      value38: 0,
      value39: 0,
      value40: 0,
      value41: 0,
      value42: 0,
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value29: "",
      value30: "",
      value31: "",
      value32: "",
      value33: "",
      value34: "",
      value35: "",
      value36: "",
      value37: 0,
      value38: 0,
      value39: 0,
      value40: 0,
      value41: 0,
      value42: 0,
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">II. CHUYỂN NHƯỢNG CHỨNG KHOÁN</Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center" }}>
                STT
                <div className="button-action" onClick={handleAdd}>
                  <button type="button">Thêm dòng</button>
                </div>
              </Td>
              <Td colSpan={3} style={{ textAlign: "center" }}>
                Thông tin cá nhân chuyển nhượng
              </Td>
              <Td colSpan={3} style={{ textAlign: "center" }}>
                Thông tin tổ chức, cá nhân nhận chuyển nhượng
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Hợp đồng chuyển nhượng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số lượng chứng khoán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Giá chuyển nhượng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNCN phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế được miễn giảm theo Hiệp định tránh đánh thuế hai lần
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế còn phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Họ và tên (*)</Td>
              <Td style={{ textAlign: "center" }}>Mã số thuế</Td>
              <Td style={{ textAlign: "center" }}>
                Số CMND/Hộ chiếu/CCCD(trường hợp chưa có mã số thuế)
              </Td>
              <Td style={{ textAlign: "center" }}>Tên tổ chức, cá nhân</Td>
              <Td style={{ textAlign: "center" }}>Mã số thuế</Td>
              <Td style={{ textAlign: "center" }}>
                Số CMND/Hộ chiếu/CCCD(trường hợp chưa có mã số thuế)
              </Td>
              <Td style={{ textAlign: "center" }}>Số</Td>
              <Td style={{ textAlign: "center" }}>Ngày/tháng/năm</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[29]</Td>
              <Td style={{ textAlign: "center" }}>[30]</Td>
              <Td style={{ textAlign: "center" }}>[31]</Td>
              <Td style={{ textAlign: "center" }}>[32]</Td>
              <Td style={{ textAlign: "center" }}>[33]</Td>
              <Td style={{ textAlign: "center" }}>[34]</Td>
              <Td style={{ textAlign: "center" }}>[35]</Td>
              <Td style={{ textAlign: "center" }}>[36]</Td>
              <Td style={{ textAlign: "center" }}>[37]</Td>
              <Td style={{ textAlign: "center" }}>[38]</Td>
              <Td style={{ textAlign: "center" }}>[39]</Td>
              <Td style={{ textAlign: "center" }}>[40]=[39]*0.1%</Td>
              <Td style={{ textAlign: "center" }}>[41]</Td>
              <Td style={{ textAlign: "center" }}>[42]=[40]-[41]</Td>
            </tr>

            {data.map((item, index) => {
              return (
                <tr key={item.id}>
                  <Td className="toggle-button" style={{ textAlign: "center" }}>
                    {index + 1}
                    <div className="button-action delete" onClick={() => handleDelete(item.id)}>
                      <button type="button">Xóa dòng</button>
                    </div>
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value30"
                      type="text"
                      value={item.value30}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value31"
                      type="text"
                      value={item.value31}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value32"
                      type="text"
                      value={item.value32}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value33"
                      type="text"
                      value={item.value33}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value34"
                      type="text"
                      value={item.value34}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value35"
                      type="text"
                      value={item.value35}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value36"
                      type="text"
                      value={item.value36}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <DatePicker
                      style={{
                        fontSize: 13,
                        color: "#495057",
                        border: "0.0625rem solid #d2d6da",
                        background: "#fff",
                        padding: "0.5rem 0.75rem",
                        width: "100%",
                        borderRadius: "0.5rem",
                      }}
                      options={{
                        locale: Vietnamese,
                        time_24hr: true,
                        dateFormat: "d-m-Y",
                        enableTime: true,
                      }}
                      name="value37"
                      onChange={(e) => setFieldValue("value37", e[0])}
                    />
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <InputTable
                      id={item.id}
                      name="value38"
                      value={item.value38}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "right" }}>
                    <InputTable
                      id={item.id}
                      name="value39"
                      value={item.value39}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                  <Td style={{ textAlign: "right" }}>
                    <InputTable
                      id={item.id}
                      name="value41"
                      value={item.value41}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
                </tr>
              );
            })}
            <tr>
              <Td colSpan={4} style={{ textAlign: "center", background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable4);

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type ?? "text"}
      style={{
        textAlign: type && type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
